import React, { useState } from 'react';
import video1 from '../../assests/vdo/v1.mp4';
import video2 from '../../assests/vdo/v2.mp4';
import video3 from '../../assests/vdo/v3.mp4';
import video4 from '../../assests/vdo/v4.mp4';
import video5 from '../../assests/vdo/v5.mp4';
import video6 from '../../assests/vdo/v6.mp4';
import video7 from '../../assests/vdo/v7.mp4';
import video8 from '../../assests/vdo/v8.mp4';
import video9 from '../../assests/vdo/v9.mp4';
import video10 from '../../assests/vdo/v10.mp4';
import video11 from '../../assests/vdo/v11.mp4';
import video12 from '../../assests/vdo/v12.mp4';
import video13 from '../../assests/vdo/v13.mp4';
import video14 from '../../assests/vdo/v14.mp4';
import video15 from '../../assests/vdo/v15.mp4';
import video16 from '../../assests/vdo/v16.mp4';
import video17 from '../../assests/vdo/v17.mp4';
import video18 from '../../assests/vdo/v18.mp4';
import video19 from '../../assests/vdo/v19.mp4';
import video20 from '../../assests/vdo/v20.mp4';

const videos = [
  video1, video2, video3, video4, video5,
  video6, video7, video8, video9, video10,
  video11, video12, video13, video14, video15,
  video16, video17, video18, video19, video20,
];




  const VdoGallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
  
    const openModal = (index) => {
      setSelectedIndex(index);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      setSelectedIndex(null);
    };
  
    const showPrevious = () => {
      const newIndex = selectedIndex > 0 ? selectedIndex - 1 : videos.length - 1;
      setSelectedIndex(newIndex);
    };
  
    const showNext = () => {
      const newIndex = selectedIndex < videos.length - 1 ? selectedIndex + 1 : 0;
      setSelectedIndex(newIndex);
    };
  
    return (
      <section id="video-gallery" className="w-full py-20">
        <div className="flex justify-center items-center text-center mb-8">
          <h2 className="text-4xl font-semibold">Video Gallery</h2>
        </div>
  
        {/* Adjust grid layout to show one video per row on mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6">
          {videos.map((src, index) => (
            <div
              className="video-card bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-transform duration-200 hover:scale-105"
              key={index}
              onClick={() => openModal(index)}
              style={{ height: '300px' }}
            >
              <video
                className="w-full h-full object-cover"
                muted
                loop
                preload="metadata"
              >
                <source src={src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
  
        {/* Modal for showing the selected video */}
        {isModalOpen && selectedIndex !== null && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
            <div className="relative w-11/12 max-w-3xl">
              <video
                className="w-full rounded-lg"
                src={videos[selectedIndex]}
                controls
                autoPlay
              />
              {/* Close button */}
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full"
              >
                ✕
              </button>
              {/* Prev button */}
              <button
                onClick={showPrevious}
                className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 text-black px-3 py-2 rounded-r-md"
              >
                ◀
              </button>
              {/* Next button */}
              <button
                onClick={showNext}
                className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 text-black px-3 py-2 rounded-l-md"
              >
                ▶
              </button>
            </div>
          </div>
        )}
      </section>
    );
  };
  
  export default VdoGallery;